import { Spinner } from '@/assets/svgs/DesignSystem/spinner/index'

const Loader = () => {
	return (
		<div className="ds-spinner" data-testid="loader-spinner">
			<Spinner className="ds-spinner-icon" />
		</div>
	);
};
export default Loader;
